import { Controller } from "@hotwired/stimulus"

// Lets a checkbox govern whether its dependent fields can be edited. Used on
// the domain rows of the delivery and payment method forms: the "offer on
// this domain" tick enables that domain's price fields, so a price typed for
// a domain that is not offered can never be silently dropped on submit. The
// fields follow the tick on connect too, so a page restored from cache or a
// failed submit is consistent with what the checkbox shows.
//
// Connects to data-controller="enable-fields"
export default class extends Controller {
  static targets = ["switch", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.switchTarget.checked

    this.fieldTargets.forEach((field) => { field.disabled = !enabled })
  }
}
